module.exports = __webpack_public_path__ + "static/media/monetizationG.0f1a5d0b.svg";